import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TaskId, User } from 'api/models';
import { Task } from 'api/tasks';
import { useNavigateToTask } from 'hooks/use-navigate-to-task';
import { InlineLink, Value } from '../../basics';
import { Causer } from '../causer';

interface Props {
  by: User;
  to: JSX.Element | null;
  task: Task;
}

export const DependencyChangedMessage: FC<Props> = ({ by, to, task }) => {
  const { taskId, taskName } = task;
  const { projectId } = task.project;
  const navigateToTask = useNavigateToTask();
  const openTaskDrawer = useCallback(() => {
    if (taskId == null || projectId == null) {
      return;
    }
    navigateToTask(TaskId(projectId, taskId));
  }, [taskId, projectId, navigateToTask]);

  return (
    <FormattedMessage
      id="notifications.messages.task_dependency_changed"
      values={{
        causer: <Causer user={by} />,
        dependencyTaskName: (
          <InlineLink title={taskName} open={openTaskDrawer} />
        ),
        to: <Value>{to}</Value>,
      }}
    />
  );
};
